"use client";

import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";

import { cn } from "@/lib/utils";

const VariantSelectorImages = ({
  className,
  onValueChange,
  value,
  variants,
}) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid grid-cols-2 gap-2 sm:grid-cols-3", className)}
      value={value}
      onValueChange={onValueChange}
    >
      {variants.map((variant) => (
        <label
          key={variant.id}
          className={cn(
            "relative flex cursor-pointer flex-col items-center gap-3 rounded-lg border px-2 py-3 text-center shadow-xs shadow-black/5 outline-offset-2 transition-colors border-input",
            variant.disabled && "cursor-not-allowed opacity-50",
            value === variant.value && "border-ring bg-accent"
          )}
        >
          <RadioGroupPrimitive.Item
            value={variant.value}
            disabled={variant.disabled}
            className="sr-only"
          >
            <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
              <Circle className="h-2.5 w-2.5 fill-current text-current" />
            </RadioGroupPrimitive.Indicator>
          </RadioGroupPrimitive.Item>
          <img
            alt={variant.label}
            src={variant.url}
            className="h-[100px] w-[100px] object-cover rounded-md"
          />
          <p className="text-muted-foreground text-xs">{variant.label}</p>
        </label>
      ))}
    </RadioGroupPrimitive.Root>
  );
};

export default VariantSelectorImages;